import { FilterBloc } from './filter_bloc/FilterBloc';
import { SubscriptionBoardBloc } from './subscription_board_bloc';
import { BaseBloc } from '@core/utils/bloc';
import { TokenData } from '@core/utils/ioc';
import { ActivityBloc } from './activity_bloc';
import { BoardBloc } from './board_bloc';
import { BrandBloc } from './brand_bloc';
import { CannedBloc } from './canned_bloc';
import { CategoryBloc } from './category_bloc';
import { ChangelogBloc } from './changelog_bloc';
import { ChannelSenderBloc } from './channel_sender_bloc/';
import { ChecklistBloc } from './checklist_bloc';
import { ChecklistTemplateBloc } from './checklist_template_bloc';
import { ChildChecklistBloc } from './child_checklist_bloc';
import { ClientFormBloc } from './client_form_bloc';
import { ClientProjectBloc } from './client_project_bloc';
import { CommentBloc } from './comment_bloc';
import { CommissionBloc } from './commission_bloc/CommissionBloc';
import { CompanyBloc } from './company_bloc';
import { CompanyStatsBloc } from './company_stats_bloc';
import { ContactBloc } from './contact_bloc';
import { CourseBloc } from './course_bloc';
import { DashboardBloc } from './dashboard_bloc';
import { DealBloc } from './deal_bloc';
import { DealBoardBloc } from './deal_board_bloc';
import { DealLostReasonBloc } from './deal_lost_reason_bloc';
import { DealStageBloc } from './deal_stage_bloc';
import { DynamincReportBloc } from './dynaminc_report_bloc';
import { EchoBloc } from './echo_bloc';
import { EmailBloc } from './email_bloc';
import { FileBloc } from './file_bloc';
import { FocusModeBloc } from './focus_mode_bloc';
import { FocusProspectFilterBloc } from './focus_prospect_filter_bloc';
import { FormBloc } from './form_bloc';
import { GlossaryBloc } from './glossary_bloc';
import { HelpArticleBloc } from './help_article_bloc';
import { HelpArticleCategoryBloc } from './help_article_category_bloc';
import { HelpArticleTagBloc } from './help_article_tag_bloc';
import { IdeaBloc } from './idea_bloc';
import { IntegrationBloc } from './integration_bloc';
import { InvoiceSettingBloc } from './invoice_setting_bloc';
import { JobBloc } from './job_bloc';
import { KnowledgeBaseBloc } from './knowledge_base_bloc';
import { LibraryBloc } from './library_bloc/LibraryBloc';
import { LineUpBloc } from './lineup_bloc';
import { LogBloc } from './log_bloc';
import { MarketingBoardBloc } from './marketing_board_bloc';
import { MarketingChecklistBloc } from './marketing_checklist_bloc';
import { MediaBloc } from './media_bloc';
import { OrderActivityBloc } from './order_activity_bloc/OrderActivityBloc';
import { OrderBloc } from './order_bloc/OrderBloc';
import { OrderProductBloc } from './order_product_bloc';
import { PurchaseOrderBloc } from './order_purchase_bloc/PurchaseOrderBloc';
import { OrderStageBloc } from './order_stage_bloc';
import { OrderTermBloc } from './order_term_bloc';
import { OrderVendorBloc } from './order_vendor_bloc';
import { OrganizationBloc } from './organization_bloc';
import { PricingTeirBloc } from './pricing_tier_bloc';
import { ProjectBloc } from './project_bloc';
import { ProjectPriorityBloc } from './project_priority_bloc';
import { ProjectStageBloc } from './project_stage_bloc';
import { ProjectTemplateBloc } from './project_template_bloc';
import { PublicFormBloc } from './public_form_bloc';
import { ReportBloc } from './report_bloc';
import { ReportCategoryBloc } from './report_category_bloc';
import { ReportSourceBloc } from './report_source_bloc/ReportSourceBloc';
import { RingCentralBloc } from './ringcentral_bloc';
import { SenderBloc } from './sender_bloc';
import { ServiceBloc } from './service_bloc';
import { ServiceClassBloc } from './service_class_bloc';
import { SettingsBloc } from './settings_bloc';
import { SharedProjectBloc } from './shared_project_bloc';
import { StoreBloc } from './store_bloc';
import { SupportCategoriesBloc } from './support_categories_bloc';
import { SupportChannelAssignBloc, SupportChannelBloc, SupportChannelRuleBloc } from './support_channel_bloc';
import { SupportTicketBloc } from './support_ticket_bloc';
import { TagBloc } from './tag_bloc';
import { RegionBloc } from './region_bloc';
import { TaskBloc } from './task_bloc';
import { TaskLinkableBloc } from './task_linkable_bloc';
import { TeamBloc } from './team_bloc';
import { TimeLogBloc } from './time_log_bloc';
import { TodoBloc } from './todo_bloc';
import { TodoChecklistBloc } from './todo_checklist_bloc';
import { Blocs } from './tokens';
import { UserBloc } from './user_bloc';
import { ReviewBloc } from './review_Bloc';
import { UserCourseBloc } from './user_course_bloc';
import { WebhookBloc } from './webhook_bloc';
import { AutomationWebhookBloc } from './automation_webhook_bloc';
import { ApiKeyBloc } from './apikey_bloc';
import { PreviewCourseBloc } from './preview_course_bloc';
import { IntegrationHelperBloc } from './integration_helper_bloc';
import { CurrencyBloc } from './currency_bloc';
import { DashboardEmailBloc } from './dashboard_emails_bloc';
import { CommissionGroupBloc } from './commission_group_bloc';
import { CommissionPeriodBloc } from './commission_period_bloc';
import { MarketingBoardBloc as MarketingBoardBlocV2 } from './marketing_board_bloc_v2';
import { ProposalTemplateBloc } from './proposal_template_bloc';
import { ProposalTemplateFolderBloc } from './proposal_template_folder_bloc';
import { ProjectTemplateFolderBloc } from './project_template_folder_bloc';
import { ProposalBloc } from './proposal_bloc';
import { OrderPackageBloc } from './order_package_bloc';
import { TmStageBloc } from './tm_stage_bloc';
import { TimeMaterialBloc } from './time_material_bloc';
import { TimeMaterialActivityBloc } from './time_material_activity_bloc';
import { LabourTypeBloc } from './labour_type_bloc';
import { TMTimeTrackingBloc } from './tm_time_tracking/TMTimeTrackingBloc';
import { TMReceivedProductBloc } from './tm_received_product/TMReceivedProductBloc';
import { TaskStatusBloc } from './task_statuses';
import { SupportTicketStatusBloc } from './support_ticket_status';
import { BlockTemplateBloc } from './block_template_bloc';
import { AuthBloc } from './auth_bloc';
import { TimeMaterialBoardBloc } from './tm_board_bloc';
import { ManagementFormBloc } from './management_form_bloc';
import { ManagementFormTemplateBloc } from './management_form_template_bloc';
import { SharedFileBloc } from './shared_file_bloc';
import { TmPhaseBloc } from './tm_phase_bloc';
import { CalendarBloc } from './calendar_bloc';
import { TMChangeOrderBoardBloc } from './tm_change_order_board_bloc';
import { TMChangeOrderBloc } from './tm_change_order_bloc';
import { ClockinBloc } from './clockin_bloc';
import { TMFeeBloc } from './tm_fee_bloc';
import { ClockinReportsBloc } from './clockin_reports_bloc/ClockinReportsBloc';
import { TMRMADamageStatusBloc } from './tm_rma_damage_status_bloc';
import { TmRMABloc } from './tm_rma_bloc';
import { PoStatusBloc } from './po_status_bloc';
import { ARDashboardBloc } from './ardashboard_bloc';
import { OrderBrandBloc } from './order_brand_bloc';
import { SupportTaskBloc } from './support_task_bloc';
import { LibraryDocumentBloc } from './library_document_bloc';
import { CourseInboxBloc } from './instructor_inbox_bloc';
import { CourseInboxReplyBloc } from './course_inbox_reply_bloc';
import { TimeoffBloc } from './timeoff_bloc';
import { AutomationBloc } from './automation_bloc';
import { PresentationBloc } from './presentation_bloc';
import { OvertimeBloc } from './overtime_bloc';
import { FormLibraryBloc } from './form_library_bloc';
import { NotificationBloc } from './notification_bloc';
import { FeedbackBloc } from './feedback_bloc';
import { CommissionOverrideBloc } from './commission_override_bloc';
import { JournalBloc } from './journal_bloc';
import { FolderBloc } from './folder_bloc';
import { ReportEmailBloc } from './report_emails_bloc';
import { NotificationSettingsBloc } from './notification_settings_bloc';
import { GCCalendarBloc, GCCalendarEventBloc } from './gc_calendar_bloc';
import { GCModuleCalendarBloc } from './gc_module_calendar_bloc';

export const BLOCS: [TokenData<BaseBloc>, Constructor<BaseBloc>][] = [
  [Blocs.compnay, CompanyBloc],
  [Blocs.brand, BrandBloc],
  [Blocs.user, UserBloc],
  [Blocs.organization, OrganizationBloc],
  [Blocs.settings, SettingsBloc],
  [Blocs.contact, ContactBloc],
  [Blocs.contactActivity, ActivityBloc],
  [Blocs.service, ServiceBloc],
  [Blocs.serviceClass, ServiceClassBloc],
  [Blocs.project, ProjectBloc],
  [Blocs.board, BoardBloc],
  [Blocs.integration, IntegrationBloc],
  [Blocs.projectTemplate, ProjectTemplateBloc],
  [Blocs.projectTemplateFolder, ProjectTemplateFolderBloc],
  [Blocs.projectStage, ProjectStageBloc],
  [Blocs.projectPriority, ProjectPriorityBloc],
  [Blocs.checklist, MarketingChecklistBloc],
  [Blocs.marketingBoard, MarketingBoardBloc],
  [Blocs.file, FileBloc],
  [Blocs.deal, DealBloc],
  [Blocs.dealBoard, DealBoardBloc],
  [Blocs.dealStage, DealStageBloc],
  [Blocs.dealLostReason, DealLostReasonBloc],
  [Blocs.form, FormBloc],
  [Blocs.supportCategory, SupportCategoriesBloc],
  [Blocs.supportChannel, SupportChannelBloc],
  [Blocs.supportChannelAssign, SupportChannelAssignBloc],
  [Blocs.supportChannelRule, SupportChannelRuleBloc],
  [Blocs.supportTicket, SupportTicketBloc],
  [Blocs.helpArticle, HelpArticleBloc],
  [Blocs.helpArticleCategory, HelpArticleCategoryBloc],
  [Blocs.helpArticleTag, HelpArticleTagBloc],
  [Blocs.echo, EchoBloc],
  [Blocs.report, ReportBloc],
  [Blocs.canned, CannedBloc],
  [Blocs.timeLog, TimeLogBloc],
  [Blocs.clientProject, ClientProjectBloc],
  [Blocs.sender, SenderBloc],
  [Blocs.channelSender, ChannelSenderBloc],
  [Blocs.ringcentral, RingCentralBloc],
  [Blocs.log, LogBloc],
  [Blocs.email, EmailBloc],
  [Blocs.media, MediaBloc],
  [Blocs.team, TeamBloc],
  [Blocs.dashboard, DashboardBloc],
  [Blocs.publicForm, PublicFormBloc],
  [Blocs.clientForm, ClientFormBloc],
  [Blocs.comment, CommentBloc],
  [Blocs.review, ReviewBloc],
  [Blocs.task, TaskBloc],
  [Blocs.taskLinkable, TaskLinkableBloc],
  [Blocs.knowledgeBase, KnowledgeBaseBloc],
  [Blocs.invoiceSetting, InvoiceSettingBloc],
  [Blocs.library, LibraryBloc],
  [Blocs.checklistTemplate, ChecklistTemplateBloc],
  [Blocs.todoChecklists, TodoChecklistBloc],
  [Blocs.course, CourseBloc],
  [Blocs.userCourse, UserCourseBloc],
  [Blocs.companyStats, CompanyStatsBloc],
  [Blocs.todoChecklist, ChecklistBloc],
  [Blocs.todo, TodoBloc],
  [Blocs.webhook, WebhookBloc],
  [Blocs.automationWebhook, AutomationWebhookBloc],
  [Blocs.store, StoreBloc],
  [Blocs.orderStage, OrderStageBloc],
  [Blocs.orderTerm, OrderTermBloc],
  [Blocs.orderVendor, OrderVendorBloc],
  [Blocs.orderProduct, OrderProductBloc],
  [Blocs.order, OrderBloc],
  [Blocs.purchaseOrder, PurchaseOrderBloc],
  [Blocs.category, CategoryBloc],
  [Blocs.pricingTeir, PricingTeirBloc],
  [Blocs.orderActivity, OrderActivityBloc],
  [Blocs.idea, IdeaBloc],
  [Blocs.tag, TagBloc],
  [Blocs.region, RegionBloc],
  [Blocs.childTodoChecklist, ChildChecklistBloc],
  [Blocs.sharedProject, SharedProjectBloc],
  [Blocs.job, JobBloc],
  [Blocs.glossary, GlossaryBloc],
  [Blocs.lineUp, LineUpBloc],
  [Blocs.reportCategory, ReportCategoryBloc],
  [Blocs.dynamincReport, DynamincReportBloc],
  [Blocs.changelog, ChangelogBloc],
  [Blocs.commission, CommissionBloc],
  [Blocs.commissionGroup, CommissionGroupBloc],
  [Blocs.apiKey, ApiKeyBloc],
  [Blocs.previewCourse, PreviewCourseBloc],
  [Blocs.reportSource, ReportSourceBloc],
  [Blocs.integrationHelper, IntegrationHelperBloc],
  [Blocs.subscriptionBoard, SubscriptionBoardBloc],
  [Blocs.currency, CurrencyBloc],
  [Blocs.dashboardEmail, DashboardEmailBloc],
  [Blocs.reportEmail, ReportEmailBloc],
  [Blocs.commissionPeriod, CommissionPeriodBloc],
  [Blocs.marketingBoardV2, MarketingBoardBlocV2],
  [Blocs.proposalTemplate, ProposalTemplateBloc],
  [Blocs.proposalTemplateFolder, ProposalTemplateFolderBloc],
  [Blocs.proposal, ProposalBloc],
  [Blocs.orderPackage, OrderPackageBloc],
  [Blocs.tmStage, TmStageBloc],
  [Blocs.timeMaterial, TimeMaterialBloc],
  [Blocs.timeMaterialActivity, TimeMaterialActivityBloc],
  [Blocs.labourTypes, LabourTypeBloc],
  [Blocs.tmTimeTracking, TMTimeTrackingBloc],
  [Blocs.tmReceivedProduct, TMReceivedProductBloc],
  [Blocs.taskStatus, TaskStatusBloc],
  [Blocs.supportTicketStatus, SupportTicketStatusBloc],
  [Blocs.blockTemplate, BlockTemplateBloc],
  [Blocs.authBloc, AuthBloc],
  [Blocs.timeMaterialBoard, TimeMaterialBoardBloc],
  [Blocs.managementForm, ManagementFormBloc],
  [Blocs.managementFormTemplates, ManagementFormTemplateBloc],
  [Blocs.sharedFile, SharedFileBloc],
  [Blocs.timeMaterialPhase, TmPhaseBloc],
  [Blocs.calendar, CalendarBloc],
  [Blocs.tmChangeOrderBoard, TMChangeOrderBoardBloc],
  [Blocs.tmChangeOrder, TMChangeOrderBloc],
  [Blocs.clockin, ClockinBloc],
  [Blocs.tmFee, TMFeeBloc],
  [Blocs.clockinReport, ClockinReportsBloc],
  [Blocs.filter, FilterBloc],
  [Blocs.tmRMADamageStatus, TMRMADamageStatusBloc],
  [Blocs.tmRMA, TmRMABloc],
  [Blocs.poStatus, PoStatusBloc],
  [Blocs.arDashboard, ARDashboardBloc],
  [Blocs.orderBrand, OrderBrandBloc],
  [Blocs.supportTask, SupportTaskBloc],
  [Blocs.libraryDocument, LibraryDocumentBloc],
  [Blocs.courseInbox, CourseInboxBloc],
  [Blocs.courseInboxReply, CourseInboxReplyBloc],
  [Blocs.timeoff, TimeoffBloc],
  [Blocs.automation, AutomationBloc],
  [Blocs.presentation, PresentationBloc],
  [Blocs.overtime, OvertimeBloc],
  [Blocs.formLibrary, FormLibraryBloc],
  [Blocs.notifications, NotificationBloc],
  [Blocs.feedback, FeedbackBloc],
  [Blocs.commissionOverrides, CommissionOverrideBloc],
  [Blocs.journal, JournalBloc],
  [Blocs.folder, FolderBloc],
  [Blocs.notificationSettings, NotificationSettingsBloc],
  [Blocs.gcCalendar, GCCalendarBloc],
  [Blocs.gcCalendarEvent, GCCalendarEventBloc],
  [Blocs.gcModuleCalendar, GCModuleCalendarBloc],
  [Blocs.focusMode, FocusModeBloc],
  [Blocs.focusProspectFilter, FocusProspectFilterBloc],
];
